import React from 'react';
import { Header2Text, Header3Text, NavigationItem } from 'ui-toolkit';

export const PreExistingContactDisplay: React.FC<{ fullName: string; email: string; companyName?: string }> = ({
  fullName,
  email,
  companyName,
}) => (
  <>
    {email && (
      <div>
        <Header2Text>{fullName}</Header2Text>
        <NavigationItem text={email} href={`mailto:${email}`} isActive isInline />
        {companyName && <Header3Text>{companyName}</Header3Text>}
      </div>
    )}
  </>
);
